import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import DollarCell from '@/backgrid/DollarCell';
import StringCell from '@/backgrid/StringCell';

import OrderSummaryGridView from '../../../views/OrderSummaryGridView/OrderSummaryGridView';

import tmplSpecialtyRequirementSummaryView from './SpecialtyRequirementSummaryView.hbs';

import './SpecialtyRequirementSummaryView.css';

const SpecialtyRequirementSummaryView = View.extend({
  template: tmplSpecialtyRequirementSummaryView,

  className: 'specialty-requirement-summary-view',

  ui: {
    specialtyRequirementSummaryTable: '.specialty-requirement-summary-table'
  },

  regions: {
    specialtyRequirementSummaryTable: '@ui.specialtyRequirementSummaryTable'
  },

  onRender() {
    const isPriceVisible = this.model.get('isPriceVisible');

    this.specialtyRequirementColumns = [
      {
        name: 'customDescription',
        label: 'Description',
        cell: StringCell,
        headerCell: 'custom',
        width: 35,
        editable: false
      },
      {
        name: 'quantity',
        label: 'Quantity',
        cell: StringCell,
        headerCell: 'custom',
        width: 8,
        editable: false
      },
      {
        name: 'price',
        label: 'Unit Price',
        cell: DollarCell,
        headerCell: 'custom',
        width: 8,
        renderable: isPriceVisible,
        editable: false
      }
    ];

    this.specialtyRequirementCollection = new Backbone.Collection(this.model.get('order'));

    this.specialtyRequirementSummaryGridView = new OrderSummaryGridView({
      model: this.model,
      collection: this.specialtyRequirementCollection,
      columns: this.specialtyRequirementColumns
    });

    this.showChildView('specialtyRequirementSummaryTable', this.specialtyRequirementSummaryGridView);
  }
});

export default SpecialtyRequirementSummaryView;
